import React from 'react'

function Hyperlink() {
    return (
        <div className="container py-5">
            <div className="card shadow-sm border-0 rounded-3">
                <div className="card-body p-4 p-md-5">
                    <h5 className="fw-bold text-success border-bottom pb-3 mb-4">
                        Hyperlinking Policy
                    </h5>

                    <span className="text-decoration-underline fst-italic mb-3 d-block" style={{ textDecorationThickness: "1px", textUnderlineOffset: "4px" }}>
                        Links to external websites/portals
                    </span>

                    <p
                        className="text-secondary lh-lg mb-4"
                        style={{ textIndent: "2.5rem" }}
                    >
                        At many places in this Website, you shall find links to other websites/portals. This links have been placed for your convenience. This Office
                        is not responsible for the contents and reliability of the linked websites and does not necessarily endorse the views expressed in them. Mere
                        presence of the link or its listing on this Website should not be assumed as endorsement of any kind. We can not guarantee that these links will
                        work all the time and we have no control over availability of linked pages.
                    </p>

                    <span className="text-decoration-underline fst-italic mb-3 d-block" style={{ textDecorationThickness: "1px", textUnderlineOffset: "4px" }}>
                        Links to this Website by other websites
                    </span>

                    <p
                        className="text-secondary lh-lg mb-4"
                        style={{ textIndent: "2.5rem" }}
                    >
                        We do not object to you linking to the information that is hosted on our site but prior permission is required for the same. However, we
                        would like you to inform us about any links provided to our site so that you can be informed of any changes or updations therein. Also, we do not
                        permit our pages to be loaded into frames on your site. Our website’s page must load into a newly opened browser window of the user.
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Hyperlink




